import { Progress } from "@au-schein-de/au-ui-library";
import { cva, type VariantProps } from "class-variance-authority";
import type { ReactNode } from "react";

const productDetailsItemContentVariants = cva(
	"flex justify-between items-center text-body-lg-emphasis md:text-h5 py-2",
	{
		variants: {
			variant: {
				default: "",
				"with-strength": "border-b border-gray-200",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

const strengthLabelVariants = cva(
	"text-ansay-700 text-caption text-left md:shrink-0",
	{
		variants: {},
		defaultVariants: {},
	},
);

type ProductDetailsItemContentProps = {
	characteristic: string;
	strength: number;
	strengthMax: number;
	icon?: ReactNode;
	strengthLabel?: string;
} & VariantProps<typeof productDetailsItemContentVariants>;

export function ProductDetailsItemContent({
	characteristic,
	variant,
	strength,
	strengthMax,
	icon,
	strengthLabel,
}: ProductDetailsItemContentProps) {
	return (
		<li className={productDetailsItemContentVariants({ variant })}>
			<div className="flex items-center gap-2">
				{icon}
				<span className="capitalize text-body-lg-emphasis md:text-h5 text-gray-700">
					{characteristic}
				</span>
			</div>

			{variant === "with-strength" && (
				<div className="flex justify-end">
					<div className="flex w-[100px] flex-col gap-1 md:w-auto md:flex-row md:items-center md:gap-2">
						{strengthLabel && (
							<span className={strengthLabelVariants()}>{strengthLabel}</span>
						)}
						<div className="w-[100px] md:w-[170px]">
							<Progress
								value={strengthMax > 0 ? (strength / strengthMax) * 100 : 0}
								variant="product-details-page"
							/>
						</div>
					</div>
				</div>
			)}
		</li>
	);
}
